import styled from 'styled-components'
import { theme } from '@notino/react-styleguide'

export const LoadingWrapper = styled.div<{ $maxWidth?: string; $maxHeight?: string; $padding?: string }>`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	min-height: ${({ $maxHeight }) => $maxHeight ?? '400px'};
	color: ${theme.color.text.primary};
	max-width: ${({ $maxWidth }) => $maxWidth ?? '100%'};
	padding: ${({ $padding }) => $padding ?? undefined};
`
